import React, { useRef, useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import BezierEasing from 'bezier-easing';
import { mergeClassNames, useInViewport, useOnce } from '../../../utils';
import { headerHeight } from '../../../utils/menuHeight';
import ArrowDown from './assets/arrow_down_circle--inverted-icon.svg';
import styles from './index.module.scss';

const sebease = BezierEasing(0, 0, 0.58, 1);

export default function ScrollToSeeMore({ className = null, animate = true, invert = false }) {
  let ref = useRef(null);
  let inView = useInViewport(ref, true);

  const arrowMotionProps = useSpring({
    from: { transform: 'translateY(-5px)' },
    to: async next => {
      while (inView && animate) {
        if (!(await next({ transform: 'translateY(5px)', config: { duration: 800, easing: sebease } }))) break;
        if (!(await next({ transform: 'translateY(5px)', config: { duration: 100, easing: sebease } }))) break;
        if (!(await next({ transform: 'translateY(-5px)', config: { duration: 400, easing: sebease } }))) break;
      }
    },
  });

  return (
    <div ref={ref} className={mergeClassNames(styles.outer, className)}>
      <animated.div style={arrowMotionProps}>
        <ArrowDown className={mergeClassNames(styles.motionElem, invert && styles.inverted)} />
      </animated.div>
    </div>
  );
}

function calcHeight() {
  const docRect = document.documentElement.getBoundingClientRect();
  return docRect.height - headerHeight;
}

export function ScrollToSeeMoreFullScreen({ className = null, animate = true, invert = false }) {
  let [windowHeight, setWindowHeight] = useState(0);

  useOnce(() => {
    setWindowHeight(calcHeight());
  });

  return (
    <div className={mergeClassNames(styles.scrollToSeeMore, styles.fullElem)} style={{ height: `${windowHeight}px` }}>
      <ScrollToSeeMore animate={animate} invert={invert} className={mergeClassNames(styles.fullOuter, className)} />
    </div>
  );
}
